export default "#define GLSLIFY 1\n#preImport <isotropyLightCompute>\n#preImport <anisotropyLightCompute>";